var map = {
	"./close_actionhandler.js": 879,
	"./externallink_actionhandler.js": 880,
	"./forgot_your_password_actionhandler.js": 881,
	"./forgot_your_username_actionhandler.js": 882,
	"./playforfun_actionhandler.js": 883,
	"./registration_actionhandler.js": 884,
	"./submit_actionhandler.js": 885
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 878;